// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var WebAdminMsgType;
(function (WebAdminMsgType) {
    WebAdminMsgType["ReloadBranding"] = "reload-branding";
    WebAdminMsgType["GetServerInfo"] = "get-server-info";
    WebAdminMsgType["GetLogs"] = "get-logs";
    WebAdminMsgType["Error"] = "error";
})(WebAdminMsgType || (WebAdminMsgType = {}));
